import React from 'react'
import PropTypes from 'prop-types'
import PDFObject from 'lib/pdfobject.min'
import browser from 'detect-browser'
import isEmpty from 'lodash/isEmpty'

const IFRAME_ELEMENT_ID = 'pdfIframe'

const AVOID_OBJECT_OS = [ "iOS", "Mac OS" ]

/* fallbackElement is used when browser doesn't support inline PDF's.
fallbackElement functions are used to support an error on google viewer's response status(204),
When fallbackElement iframe content is not loaded a reload process is initiated */
const HIDDEN_TOOLBAR_FRAGMENT_IDENTIFIERS = 'toolbar=0&navpanes=0'
const RESPONSIVE_FRAGMENT_IDENTIFIER = 'view=FitH'

class PDF extends React.Component {
  constructor(props) {
    super(props)
    this.pdfUrl = props.blockDownload ? this.addUrlFragmentIdentifier(props.url, HIDDEN_TOOLBAR_FRAGMENT_IDENTIFIERS) : props.url
    this.iframeLink = `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(this.pdfUrl)}`
    this.iframeTimeoutId = null
  }

  componentDidMount() {
    this.handleNewItem()
  }

  componentWillUnmount() {
    this.clearFallbackElementTimeout()
  }

  componentDidUpdate(prevProps) {
    prevProps.url != this.props.url && this.handleNewItem()
  }

  setFallbackElement = () => {
    const fallbackElement = document.getElementById(IFRAME_ELEMENT_ID)

    if (fallbackElement) {
      fallbackElement.onload = this.handleFallBackElementLoad
      fallbackElement.onerror = this.handleFallBackElementReload
      this.setFallbackElementTimeout()
    }
  }

  setFallbackElementTimeout = () => {
    this.clearFallbackElementTimeout()
    this.iframeTimeoutId = setTimeout(this.handleFallBackElementReload, 3000)
  }

  clearFallbackElementTimeout = () => {
    clearInterval(this.iframeTimeoutId)
  }

  handleFallBackElementLoad = () => {
    const fallbackElement = document.getElementById(IFRAME_ELEMENT_ID)

    if (fallbackElement) {
      const contentLoaded = fallbackElement.contentWindow.length

      if (!!contentLoaded) {
        this.clearFallbackElementTimeout()
      }
      else {
        this.handleFallBackElementReload()
      }
    }
  }

  handleFallBackElementReload = () => {
    const fallbackElement = document.getElementById(IFRAME_ELEMENT_ID)

    if (fallbackElement) {
      fallbackElement.src = this.iframeLink
      this.setFallbackElementTimeout()
    }
  }

  withoutObject = () => {
    return isEmpty(browser) || AVOID_OBJECT_OS.includes(browser.os)
  }

  addUrlFragmentIdentifier = (url, identifier) => {
    const hashSym = "#"

    let [baseUrl, fragmentIdentifiers=identifier] = url.split(hashSym)
    let result = baseUrl + hashSym + fragmentIdentifiers

    if (fragmentIdentifiers.includes(identifier)) {
      return result
    }

    return result + "&" + identifier
  }

  handleNewItem = () => {
    const pdfUrl = this.addUrlFragmentIdentifier(this.pdfUrl, RESPONSIVE_FRAGMENT_IDENTIFIER)

    const fallbackElement = `<iframe
      id=${IFRAME_ELEMENT_ID}
      src='${this.iframeLink}'
      title="Viewer: PDF item" allowfullscreen />`

    const options = {
      fallbackLink: this.withoutObject() ? fallbackElement : `<object data=${this.pdfUrl} type="application/pdf">${fallbackElement}</object>`
    }

    PDFObject.embed(decodeURI(pdfUrl), this.pdfContainer, options)
    this.setFallbackElement()
  }



  render() {
    return <div className="pdf-container" ref={ref => this.pdfContainer = ref} />
  }
}

PDF.propTypes = {
  url: PropTypes.string.isRequired,
  blockDownload: PropTypes.bool
}

PDF.defaultProps = {
  blockDownload: false
}

export default PDF